import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CircleNotch, Crown } from "@phosphor-icons/react";
import AdminLayout from "@/pages/admin/AdminLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "caus_super_token";

const inputCls =
  "rounded-sm border-input bg-background text-foreground placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0";

export default function Admin() {
  const [token, setToken] = useState(() => sessionStorage.getItem(TOKEN_KEY) || "");
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/superadmin/login`, form);
      sessionStorage.setItem(TOKEN_KEY, data.token);
      setToken(data.token);
    } catch (err) {
      setError(err.response?.data?.detail || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    setToken("");
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="superadmin-login">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-8">
            <Crown size={22} className="text-primary" />
            <h1 className="font-heading text-2xl font-black tracking-tight text-foreground">CAUS · Plataforma</h1>
          </div>
          <form onSubmit={login} className="space-y-5" data-testid="superadmin-form">
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-widest text-muted-foreground">Usuario</Label>
              <Input className={inputCls} data-testid="superadmin-username" value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })} required autoComplete="username" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-widest text-muted-foreground">Contraseña</Label>
              <Input type="password" className={inputCls} data-testid="superadmin-password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} required autoComplete="current-password" />
            </div>
            {error && (
              <p className="border border-red-900/60 bg-red-950/30 px-3 py-2 text-sm text-red-400" data-testid="superadmin-error">{error}</p>
            )}
            <Button type="submit" disabled={loading} className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/80" data-testid="superadmin-submit">
              {loading && <CircleNotch className="animate-spin mr-2" size={16} />} Entrar
            </Button>
          </form>
        </div>
      </div>
    );
  }

  return <AdminLayout onLogout={logout} />;
}
